export default __webpack_public_path__ + "static/media/store.654b8349.png";